import { oz } from '@weft/utils';

export const InviteUserResponseSchema = oz.object({}).openapi('InviteUserResponseSchema');

export type InviteUserResponse = oz.infer<typeof InviteUserResponseSchema>;